/** Display formatting for national phone numbers (digits-only storage). */

const PHONE_GROUP_RULES: Record<string, number[]> = {
  '34': [3, 3, 3],
  '91': [5, 5],
  '1': [3, 3, 4],
  '44': [5, 3, 3],
  '33': [2, 2, 2, 2, 2],
  '49': [4],
  '39': [3, 3, 4],
  '55': [2, 5, 4],
  '61': [4, 3, 3],
};

function digitsOnly(value: string): string {
  return String(value ?? '').replace(/\D/g, '');
}

function dialDigits(dialCode: string): string {
  return digitsOnly(dialCode);
}

function formatUS(d: string): string {
  const area = d.slice(0, 3);
  const mid = d.slice(3, 6);
  const last = d.slice(6, 10);
  if (!mid) return area;
  if (!last) return `${area} ${mid}`;
  return `${area} ${mid} ${last}`;
}

function formatBR(d: string): string {
  const area = d.slice(0, 2);
  const mid = d.slice(2, 7);
  const last = d.slice(7, 11);
  if (!mid) return area;
  if (!last) return `${area} ${mid}`;
  return `${area} ${mid} ${last}`;
}

/**
 * Format national digits for display based on country dial code.
 * Stored / API values should remain digits-only.
 */
export function formatNationalPhone(digits: string, dialCode: string): string {
  const clean = digitsOnly(digits);
  if (!clean) return '';
  const dial = dialDigits(dialCode);

  if (dial === '1') return formatUS(clean);
  if (dial === '55') return formatBR(clean);

  const groups = PHONE_GROUP_RULES[dial] || [3, 3, 3];
  const out: string[] = [];
  let idx = 0;
  for (const size of groups) {
    if (idx >= clean.length) break;
    out.push(clean.slice(idx, idx + size));
    idx += size;
  }
  if (idx < clean.length) out.push(clean.slice(idx));
  return out.join(' ');
}

/** Map caret from digit-count back into a formatted string. */
export function caretPosFromDigitsCount(formatted: string, digitsCount: number): number {
  if (!formatted) return 0;
  if (!digitsCount || digitsCount <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i += 1) {
    if (/\d/.test(formatted[i])) seen += 1;
    if (seen >= digitsCount) return i + 1;
  }
  return formatted.length;
}
